import type { QueryClient, QueryKey, Updater } from "@tanstack/react-query";

/** Écrit la valeur et annule le chargement en cours, qui l'écraserait sinon avec un état plus ancien. */
export const setQueryDataOverFetch = <T>(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: Updater<T | undefined, T | undefined>,
): void => {
    if (queryClient.setQueryData<T>(queryKey, updater) !== undefined) {
        void queryClient.cancelQueries({ queryKey, exact: true });
    }
};
